import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export interface QChatUserData {
  firstName?: string;
  lastName?: string;
  email: string;
  iin: string;
  patronymic?: string;
  phone?: string;
  customer_id: number;
  account_id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class QChatControllerService {
  constructor(private http: HttpClient) {}

  getQChatUserId(data: QChatUserData): Observable<string | null> {
    return this.http.post<{ qboxUserId: string | null }>(
      '/proxy/profile-api.bpmn/api/v1/qbox/customers',
      data
    ).pipe(
      map(response => response.qboxUserId)
    );
  }
}
